// extracted by mini-css-extract-plugin
export default {"player":"player--lWQvN","playPause":"playPause--txpjp"};